import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'antd';

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { SiteList, SiteForm } from 'components/blocks/site';


class SiteListScreen extends Component {
    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.siteShowEditForm({ show: true, object: item });
    };

    render() {
        const { history } = this.props;

        return (
            <Page>
                <PageHeader
                    title="Сайты"
                    actions={[
                        <Button type="primary" className="" icon="plus" onClick={() => this.showEditForm()}>
                            Добавить сайт
                        </Button>
                    ]}
                />

                <div className="page-content page-content-full">
                    <div className="page-block page-block-full">
                        <SiteList basePath="/site" history={history}/>
                    </div>
                </div>

                <SiteForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        site: state.site,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.site), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(SiteListScreen);
